export default __webpack_public_path__ + "static/media/Vambraces of the Beyond.a2cd848a.jpg";